import Vue from 'vue'

function defaultHttp () {
  return Vue.prototype.$http
}

Vue.prototype.$api = {
  persons () {
    const resource = 'persons'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  users () {
    const resource = 'users'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      showAuthorized: () => defaultHttp().get('/api/user'),
      updateLastLogin: (data) => defaultHttp().patch(`/api/user-last-login`, data),
    }
  },
  notifications () {
    const resource = 'notifications'

    return {
      list: () => defaultHttp().get(`/api/user/${resource}`),
      update: () => defaultHttp().patch(`/api/user/${resource}`),
    }
  },
  cities () {
    const resource = 'cities'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  employees () {
    const resource = 'employees'

    return {
      list: (param = '') => defaultHttp().get('/api/' + resource + param),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      createEmployeePerson: (data) => defaultHttp().post('/api/employee-persons', data),
      show: (id) => defaultHttp().get('/api/' + resource + '/' + id),
      showOverview: (id) => defaultHttp().get(`/api/${resource}/${id}/employee-overview`),
      saveAsDraft: (data) => defaultHttp().post('/api/employee-save-draft', data),
      checkWorkspaceEmployee: (id) => defaultHttp().get(`/api/${resource}/${id}/workspace`),
    }
  },
  adminStateEmployees () {
    const resource = 'admin-state-employees'

    return {
      list: (param) => defaultHttp().get(`/api/${resource}${param}`),
    }
  },
  employeeWorkdays () {
    const parentResource = 'employees'
    const resource = 'workdays'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
    }
  },
  leaveTypes () {
    const resource = 'leave-types'

    return {
      list: () => defaultHttp().get('/api/' + resource),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch('/api/trashed-' + resource + '/' + id),
    }
  },
  roles (type) {
    const resource = type === 'hris' ? 'hris-roles' : `${type}-roles`

    return {
      list: () => defaultHttp().get('/api/' + resource),
    }
  },
  identityCards () {
    const childResource = 'identityCards'

    return {
      showPerson: (ic) => defaultHttp().get('/api/' + childResource + '/' + ic + '/person'),
    }
  },
  lookups () {
    const resource = 'hris-lookups'

    return {
      list: (type = '') => defaultHttp().get('/api/' + resource + '?filter[type]=' + type),
    }
  },
  states () {
    const resource = 'states'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  postcodes () {
    const resource = 'postcodes'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  branches () {
    const resource = 'branches'
    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}` + param),
      show: (id) => defaultHttp().get(`/api/${resource}/` + id),
    }
  },
  userPermissions () {
    return {
      listAuthorized: () => defaultHttp().get('/api/user/permissions'),
      show: (id, name) => defaultHttp().get(`/api/users/${id}/permissions/${name}`),
    }
  },
  reportTo () {
    const parentResource = 'employees'
    const childResource = 'report-to'

    return {
      overview: () => defaultHttp().get(`/api/${childResource}` + '-overview'),
      show: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  positionApproval () {
    const parentResource = 'positions'
    const resource = 'approval'

    return {
      list: (parentId, tabType, subTab) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}/${tabType}/${subTab}`),
      update: (parentId, data, tabType, subTab) => defaultHttp().put(`/api/${parentResource}/${parentId}/${resource}/${tabType}/${subTab}`, data),
    }
  },
  positions () {
    const resource = 'positions'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}` + param),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  employeePositions () {
    const parentResource = 'employees'
    const singleChildResource = 'position'

    return {
      show: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${singleChildResource}`),
    }
  },
  leaveSessions () {
    let resource = 'leave-sessions'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  leaveApplications () {
    const parentResource = 'employees'
    const secondParentResource = 'leave-entitlements'
    const childResource = 'leave-applications'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (secondParentId, data) => defaultHttp().post(`/api/${secondParentResource}/${secondParentId}/${childResource}`, data),
      show: (data) => defaultHttp().post(`/api/${secondParentResource}-by-year`, data),
      override: (secondParentId, data) => defaultHttp().post(`/api/${childResource}/${secondParentId}/override`, data),
      cancel: (childId) => defaultHttp().post(`/api/${childResource}/${childId}/cancel`),
    }
  },
  employeeLeaveEntitlements () {
    const parentResource = 'leave-entitlements'

    return {
      list: (parentId) => defaultHttp().get(`/api/employees/${parentId}/${parentResource}`),
    }
  },
  coworkerWithLeaves () {
    const parentResource = 'employees'
    const childResource = 'coworkers-leaves'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      subordinateOnLeave: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}/subordinateOnLeave`, data),
    }
  },
  subordinateWithLeaves () {
    const parentResource = 'employee'
    const childResource = 'subordinates-leaves'

    return {
      list: () => defaultHttp().get(`/api/${parentResource}/${childResource}`),
    }
  },
  leaveRequestApprovals () {
    const parentResource = 'leave-approval-requests'
    const childResource = 'leave-approvals'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  leaveApprovals () {
    const resource = 'leave-approvals'

    return {
      approve: (childId, data) => defaultHttp().patch(`/api/${resource}/${childId}/approve`, data),
      reject: (childId, data) => defaultHttp().patch(`/api/${resource}/${childId}/reject`, data),
      pendingCount: () => defaultHttp().get(`/api/${resource}/pending-count`),
    }
  },
  employeeLeaveApprovals () {
    const parentResource = 'employees'
    const childResource = 'leave-approvals'

    return {
      list: (parentId, param, id) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}` + param, id),
    }
  },
  approvalStatus () {
    const resource = 'approval-status'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}`),
    }
  },
  leaveEntitlementSettingDetails () {
    const resource = 'leave-entitlement-setting-details'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (parentId, data) => defaultHttp().patch(`/api/leave-entitlement-settings/${parentId}/${resource}`, data),
    }
  },
  employeeLeaveEntitlementSettings () {
    const resource = 'employees'
    const childResource = 'leave-entitlement-settings'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}/${id}/${childResource}`),
    }
  },
  leaveReports () {
    return {
      generateRemainingLeaveBalance: (data, config = {}) => defaultHttp().post(`/api/remaining-leave-balance-report`, data, { responseType: 'blob', ...config }),
      approvedLeaveYears: () => defaultHttp().get(`/api/approved-leave-years`),
      generateLeaveReport: (data, config = {}) => defaultHttp().post(`/api/leave-report`, data, { responseType: 'blob', ...config }),
      subordinateRemainingLeaveBalance: (data, config = {}) => defaultHttp().post(`/api/subordinate-remaining-leave-balance`, data, { responseType: 'blob', ...config }),
      subordinateLeaveYears: () => defaultHttp().get(`/api/subordinates-remaining-leave-balance-years`),
      subordinateApprovedLeave: (data, config = {}) => defaultHttp().post(`/api/subordinate-approved-leave-report`, data, { responseType: 'blob', ...config }),
    }
  },
  officeLocations () {
    const resource = 'office-locations'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      overview: (param, data) => defaultHttp().post(`/api/office-location-overview` + param, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  employeeOfficeLocations () {
    const resource = 'employees'
    const childResource = 'office-locations'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}/${id}/${childResource}`),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}/${childResource}`, data),
    }
  },
  employeeClockInSessions () {
    let childResource = 'clock-in-session-months'

    return {
      listClockInSessionDate: () => defaultHttp().get(`/api/${childResource}`),
    }
  },
  employeeBranchHistory () {
    let resource = 'employees'
    let childResource = 'employee-branch-histories'

    return {
      list: (parentId) => defaultHttp().get(`/api/${resource}/${parentId}/${childResource}`),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data), 
    }
  },
  payrollBanks () {
    let resource = 'payroll-banks'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get('/api/trashed-' + resource),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data), 
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch('/api/trashed-' + resource + `/${id}`),
    }
  },
  companyBanks () {
    let resource = 'company-banks'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  leaveEntitlementAdjustments () {
    const resource = 'leave-entitlement-adjustments'

    return {
      create: (data) => defaultHttp().request({
        url: `/api/${resource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
    }
  },
  countries () {
    const resource = 'countries'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
    }
  },
  onBehalfLeaveApplications () {
    let resource = 'on-behalf-leaves'
    
    return {
      list: (data) => defaultHttp().post(`/api/list-${resource}`, data),
      create: (data) => defaultHttp().post(`/api/create-${resource}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  applyOnBehalfLeaveTypes () {
    return {
      list: () => defaultHttp().get(`/api/apply-on-behalf-leave-types`),
    }
  },
  employeeOnBehalfLeaveEntitlements () {
    return {
      list: () => defaultHttp().get(`/api/employee-on-behalf-leave-entitlements`),
    }
  },
  entitlementLeaveApplications () {
    const parentResource = 'leave-entitlements'
    const childResource = 'leave-applications'

    return {
      list: (parentId) => defaultHttp().get(`/api/hr/${parentResource}/${parentId}/${childResource}`),
      cancel: (childId, data) => defaultHttp().post(`/api/hr/${parentResource}/${childResource}/${childId}/cancel`, data),
      listLeaveApplicationsToSync: (param = '') => defaultHttp().get(`/api/hr/${parentResource}/${childResource}/unpaid-leaves-to-sync` + param),
    }
  },
  attendances () {
    const resource = 'attendance-imports'

    return {
      import: (data) => defaultHttp().post(`/api/${resource}`, data),
      sync: (data) => defaultHttp().post(`/api/${resource}/sync`, data),
      export: (data) => defaultHttp().post(`/api/attendances/export`, data, { responseType: 'blob' }),
      list: () => defaultHttp().get(`/api/all/attendances/month`),
      delete: (id) => defaultHttp().delete(`/api/attendances/${id}`),
    }
  },
  myAttendances () {
    const parentResource = 'me'
    const childResource = 'attendances'

    return {
      download: (data) => defaultHttp().post(`/api/${parentResource}/${childResource}/download`, data, { responseType: 'blob' }),
    }
  },
    
    //* ********************************** *//
    // HRISSSSS
    //* ********************************** *//
 
  employeeOverviews () {
    const resource = 'employee-overviews'

    return {
      list: (param, data) => defaultHttp().post(`/api/${resource}` + param, data),
    }
  },
  hrisEmployees () {
    const resource = 'employees'

    return {
      list: (param = '') => defaultHttp().get('/api/hris-' + resource + param),
      show: (id, status = '') => defaultHttp().get(`/api/hris-${resource}/${id}` + status),
      listSuperior: (id) => defaultHttp().get(`/api/employee-superior/${id}`),
    }
  },
  hrisRelationships () {
    let resource = 'relationships'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
    }
  },
  emergencyContacts () {
    let parentResource = 'employees'
    let childResource = 'emergency-contacts'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/emergency-contact`, data),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
    }
  },
  beneficiaries () {
    let parentResource = 'employees'
    let childResource = 'beneficiaries'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/beneficiary`, data),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
    }
  },
  hrisEducationBackgrounds () {
    let parentResource = 'employees'
    let childResource = 'education-backgrounds'

    return {
      list: (id) => defaultHttp().get(`/api/hris/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/hris/${parentResource}/${id}/education-background`, data),
      update: (id, data) => defaultHttp().put(`/api/hris-${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${childResource}/${id}`),
    }
  },
  hrisEducationLevels () {
    let resource = 'education-levels'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/hris-${resource}/${id}`, data), 
      destroy: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
    }
  },
  hrisEducationMajors () {
    let resource = 'education-majors'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/hris-${resource}/${id}`, data), 
      destroy: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
    }
  },
  hrisEducationInstitutes () {
    let resource = 'education-institutes'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/hris-${resource}/${id}`, data), 
      destroy: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
    }
  },
  hrisCountries () {
    let resource = 'countries'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
    }
  },
  hrisWorkingExperiences () {
    let parentResource = 'employees'
    let childResource = 'working-experiences'

    return {
      list: (id) => defaultHttp().get(`/api/hris/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/hris/${parentResource}/${id}/working-experience`, data),
      update: (id, data) => defaultHttp().put(`/api/hris-${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${childResource}/${id}`),
    }
  },
  hrisDependents () {
    let parentResource = 'employees'
    let childResource = 'dependents'

    return {
      list: (id) => defaultHttp().get(`/api/hris/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/hris/${parentResource}/${id}/dependent`, data),
      update: (id, data) => defaultHttp().put(`/api/hris-${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${childResource}/${id}`),
    }
  },
  hrisDependentHistories () {
    let parentResource = 'dependents'
    let childResource = 'histories'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/history`, data),
      update: (id, data) => defaultHttp().put(`/api/dependent-${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/dependent-${childResource}/${id}`),
    }
  },
  personHistories () {
    let parentResource = 'persons'
    let childResource = 'histories'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/history`, data),
      update: (id, data) => defaultHttp().put(`/api/person-${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/person-${childResource}/${id}`),
    }
  },
  hrisRelationStatuses () {
    let resource = 'relation-statuses'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
    }
  },
  hrisDependentDocuments () {
    let parentResource = 'dependents'
    let childResource = 'documents'

    return {
      create: (id, data) => defaultHttp().post(`/api/hris-${parentResource}/${id}/${childResource}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${parentResource}/${childResource}/${id}`),
    }
  },
  personalDetails () {
    let parentResource = 'employees'
    let childResource = 'personal-details'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (id, data) => defaultHttp().put(`/api/${parentResource}/${id}/${childResource}`, data),
     }
  },
  identityDocumentHistories () {
    let resource = 'identity-document-histories'

    return {
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
    }
  },
  genders () {
    let resource = 'genders'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  ethnicities () {
    let resource = 'ethnicities'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  citizenships () {
    let resource = 'citizenships'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  placeOfBirths () {
    let resource = 'place-of-births'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  hrisPersonMaritalStatus () {
    let resource = 'marital-status'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  religions () {
    let resource = 'religions'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  titles () {
    let resource = 'titles'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  avatars () {
    let resource = 'employees'

    return {
      upload: (id, data) => defaultHttp().post(`/api/hris/${resource}/${id}/avatar`, data),
    }
  },
  jobDetails () {
    let parentResource = 'employees'
    let childResource = 'job-details'
   
    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (id, data) => defaultHttp().put(`/api/${parentResource}/${id}/${childResource}`, data),
    }
  },
  hrisDepartments () {
    let resource = 'departments'

    return {
      list: (sorts = [], withTrashed = false, noPermission = false) => {
        let query = `/api/hris-${resource}`

        if (sorts.length > 0) {
          query += `?sort=${sorts.join()}`
        }
        if (withTrashed) {
          query += `${sorts.length > 0 ? '&' : '?'}filter[withTrashed]=true`
        }
        if (noPermission) {
          query += `${sorts.length > 0 || withTrashed ? '&' : '?'}noPermission=true`
        }
        return defaultHttp().get(query)
      },
      listTrashed: () => defaultHttp().get(`/api/hris-trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/hris-${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/hris-trashed-${resource}/${id}`),
    }
  },
  hrisSections () {
    let resource = 'sections'

    return {
      list: (sorts = [], withTrashed) => defaultHttp().get(`/api/hris-${resource}${sorts.length > 0 ? `?sort=${sorts.join()}` : ''}${withTrashed ? '?filter[withTrashed]=true' : ''}`),
      listTrashed: () => defaultHttp().get(`/api/hris-trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/hris-${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/hris-trashed-${resource}/${id}`),
    }
  },
  hrisEmployeePositions () {
    let parentResource = 'employees'
    let childResource = 'positions'

    return {
      create: (id, data) => defaultHttp().post(`/api/hris/${parentResource}/${id}/${childResource}`, data),
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/position-records`),
      update: (id, data) => defaultHttp().put(`/api/hris/employee-positions/${id}`, data),
      listYears: () => defaultHttp().get(`/api/employee-${childResource}/letter-date-years`),
      listEmployees: () => defaultHttp().get(`/api/employee-${childResource}/list-employees`),
      generateLetter: (data) => defaultHttp().post(`/api/employee-${childResource}/generate-letters`, data),
    }
  },
  hrisEmployeeDepartments () {
    let parentResource = 'employees'

    return {
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/department-records`),
      update: (id, data) => defaultHttp().put(`/api/hris/employee-departments/${id}`, data),
    }
  },
  hrisCities () {
    let resource = 'cities'

    return {
      list: () => defaultHttp().get(`api/hris/${resource}`) }
  },
  hrisStates () {
    let resource = 'states'
    
    return {
      list: () => defaultHttp().get(`api/hris/${resource}`) }
  },
  hrisEmployeeCities () {
    const parentResource = 'employees'
    const resource = 'cities'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/hris/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  hrisSeparationTypes () {
    const resource = 'separation-types'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
      listTrashed: () => defaultHttp().get(`/api/hris-trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/hris-${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/hris-trashed-${resource}/${id}`),
    }
  },
  separationReasons () {
    const resource = 'separation-reasons'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  hrisEmployeeSeparations () {
    const parentResource = 'employees'
    const childResource = 'separations'

    return {
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/hris/${parentResource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/hris/${childResource}/${id}`, data),
      upload: (childId, data) => defaultHttp().post(`/api/hris/${childResource}/${childId}/documents`, data),
      delete: (id, config = {}) => defaultHttp().delete(`/api/hris/${childResource}/${id}`, config),
    }
  },
  hrisEmployeeWorkDays () {
    const parentResource = 'employees'
    const childResource = 'workdays'

    return {
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/hris/${parentResource}/${parentId}/${childResource}`, data),
      update: (parentId, data) => defaultHttp().patch(`/api/hris/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  workSessionTypes () {
    let resource = 'work-session-types'

    return {
      list: (param) => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
    }
  },
  hrisLeaveSessions () {
    let resource = 'leave-sessions'

    return {
      list: () => defaultHttp().get(`/api/hris/${resource}`),
    }
  },
  hrisReportTo () {
    const parentResource = 'employees'
    const childResource = 'report-to'

    return {
      show: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/hris/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  bulkCreateReportTo () {
    const parentResource = 'employees'
    const childResource = 'report-to'
    
    return {
      bulkCreate: (data) => defaultHttp().post(`/api/hris/${parentResource}/${childResource}`, data),
    }
  },
  hrisSubordinates () {
    const parentResource = 'employees'
    const childResource = 'subordinates'

    return {
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/${childResource}`),
    } 
  },
  departmentWithLeaves () {
    const parentResource = 'employee'
    const childResource = 'department-leaves'

    return {
      list: (data) => defaultHttp().post(`/api/${parentResource}/${childResource}`, data),
    }
  },
  departmentLeaveDashboards () {
    const resource = 'department-leave-dashboards'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  hrisEmployeeAttendanceSettings () {
    const parentResource = 'employees'
    const resource = 'attendance-settings'

    return {
      update: (parentId, data) => defaultHttp().patch(`/api/hris/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  notificationTypes () {
    const resource = 'notification-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  hrisEmployeeNotifications () {
    const parentResource = 'employees'
    const childResource = 'notifications'

    return {
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/hris/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  hrisUserRoles (type) {
    const parentResource = 'users'
    const childResource = type !== 'hris' ? `${type}-roles` : 'roles'

    return {
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/hris/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  hrisUserTempRoles (type) {
    const parentResource = 'users'
    const childResource = type !== 'hris' ? `temp-${type}-roles` : 'temp-roles'

    return {
      list: (parentId) => defaultHttp().get(`/api/hris/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/hris/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  approveOnBehalfScopes () {
    const parentResource = 'employees'
    const childResource = 'approve-on-behalf-scopes'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  employeeReports () {
    const resource = 'employees'
    
    return {
      headCountReport: (data) => defaultHttp().post(`/api/${resource}-head-count-reports`, data, { responseType: 'blob' }),
      detailsReport: (data) => defaultHttp().post(`/api/${resource}-detail-reports`, data, { responseType: 'blob' }),
      familyDetailsReport: (data) => defaultHttp().post(`/api/${resource}-family-detail-reports`, data, { responseType: 'blob' }),
      educationDetailsReport: (data) => defaultHttp().post(`/api/${resource}-education-detail-reports`, data, { responseType: 'blob' }),
      movementReport: (data) => defaultHttp().post(`/api/employee-movement-reports`, data, { responseType: 'blob' }),
      disciplinaryReport: (data) => defaultHttp().post(`/api/employee-disciplinary-reports`, data, { responseType: 'blob' }),
      payrollCompReport: (data) => defaultHttp().post(`/api/employee-payroll-company-reports`, data, { responseType: 'blob' }),
    }
  },
  hrisCompanies () {
    const resource = 'companies'

    return {
      list: (param = '') => defaultHttp().get(`/api/hris-${resource}${param}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/hris-${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
      listTrashed: () => defaultHttp().get(`/api/hris-trashed-${resource}`),
      restore: (id) => defaultHttp().patch(`/api/hris-trashed-${resource}/${id}`),
    }
  },
  hrisCompanyBranches () {
    const parentResource = 'companies'
    const childResource = 'branches'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  hrisBranches () {
    const resource = 'branches'

    return {
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/hris-${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
    }
  },
  costCenters () {
    const parentResource = 'companies'
    const resource = 'cost-centers'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data), 
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      listAll: () => defaultHttp().get(`/api/all-${resource}`),
    }
  },
  systemSettings () {
    const resource = 'system-settings'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
      update: (id, data) => defaultHttp().put(`/api/hris-${resource}/${id}`, data),
    }
  },
  rehireEmployees () {
    const parentResource = 'employees'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${parentResource}/${id}/rehire`, data),
    }
  },
  rejoinEmployees () {
    const parentResource = 'employees'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${parentResource}/${id}/rejoin`, data),
    }
  },
  hrisPayrollCycles () {
    const resource = 'payroll-cycles'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  cutoffTypes () {
    const resource = 'cutoff-types'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}${param}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  deductionOrEarnings () {
    const resource = 'deduction-or-earnings'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}${param}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  doeCategories () {
    const resource = 'doe-categories'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  taxReliefs () {
    let resource = 'tax-reliefs'

    return {
      list: (data) => defaultHttp().post(`/api/get-${resource}`, data),
      listTrashed: (data) => defaultHttp().post(`/api/trashed-${resource}`, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      createMany: (data) => defaultHttp().post(`/api/copy-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
      listYears: () => defaultHttp().get(`/api/tax-relief-years`),
    }
  },
  contributionDeductionRevisions () {
    let resource = 'contribution-deduction-revisions'

    return {
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      create: (id, data) => defaultHttp().post(`/api/contribution-deductions/${id}/${resource}`, data),
    }
  },
  contributionDeductions () {
    let resource = 'contribution-deductions'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}${param}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  codRevisionTypes (type) {
    const resource = type === 'eis' ? type : `${type}s`

    return {
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
    }
  },
  taxExemptions () {
    let resource = 'tax-exemptions'

    return {
      list: (data) => defaultHttp().post(`/api/get-${resource}`, data),
      listTrashed: (data) => defaultHttp().post(`/api/trashed-${resource}`, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      createMany: (data) => defaultHttp().post(`/api/copy-${resource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
      listYears: () => defaultHttp().get(`/api/tax-exemption-years`),
    }
  },
  hrisCompanyEmployees () {
    const resource = 'company-employees'
   
    return {
      list: (param = '') => defaultHttp().get(`/api/hris-${resource}` + param),
      show: (id) => defaultHttp().get(`/api/hris-${resource}/${id}/show`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/hris-${resource}/${id}`, data),
      updateCompanyEmployee: (id, data) => defaultHttp().patch(`/api/hris-${resource}/${id}/update`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
      getEmail: (data) => defaultHttp().post(`/api/hris-${resource}/email`, data),
    }
  },
  companyEmployeeDocuments () {
    const resource = 'company-employee-documents'
   
    return {
      list: (data) => defaultHttp().post(`/api/${resource}`, data),
      show: (id, type = '') => defaultHttp().get(`/api/${resource}/${id}` + type),
    }
  },
  employeePayrollBanks () {
    const parentResource = 'employees'
    const childResource = 'bank-account'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  paymentMethods () {
    let resource = 'payment-methods'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  hrisPreviousRemunerations () {
    const parentResource = 'company-employees'
    const childResource = 'previous-remunerations'
    
    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (childId, data) => defaultHttp().put(`/api/${childResource}/${childId}`, data),
    }
  },
  companyEmployeeDeductionOrEarnings () {
    const parentResource = 'company-employees'
    const resource = 'company-employee-does'

    return {
      createMany: (data) => defaultHttp().post(`/api/${resource}-store-many`, data),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  companyEmployeeEpfContributions () {
    const parentResource = 'company-employees'
    const resource = 'employee-epf-contributions'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  companyEmployeeSocsoContributions () {
    const parentResource = 'company-employees'
    const resource = 'employee-socso-contributions'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  companyEmployeeEisContributions () {
    const parentResource = 'company-employees'
    const resource = 'employee-eis-contributions'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  payrollPeriods () {
    const resource = 'payroll-periods'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}` + param),
      show: (date, param = '') => defaultHttp().get(`/api/${resource}/${date}` + param),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      close: (data) => defaultHttp().patch(`/api/${resource}/close`, data),
    }
  },
  payrollPeriodCycles () {
    const parentResource = 'payroll-periods'
    const childResource = 'payroll-cycle'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  passwordAttempts () {
    const parentResource = 'users'
    const childResource = 'password-attempts'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  changePassword () {
    const parentResource = 'users'
    const childResource = 'change-passwords'

    return {
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  payrollCyclePartTimeEmployeeSalaries () {
    const parentResource = 'payroll-cycle-transactions'
    const childResource = 'part-time-employee-salaries'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/payroll-cycle-part-time-employee-salaries/${id}`, data),
    }
  },
  payrollCycleTransactions () {
    const parentResource = 'payroll-cycles'
    const secondaryParentResource = 'payroll-periods'
    const childResource = 'transaction'

    return {
      list: (id) => defaultHttp().get(`/api/payroll-cycle-transactions/${id}/employees`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
      report: (parentId, data, config = {}) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}-report`, data, { responseType: 'blob', ...config }),
      show: (id) => defaultHttp().get(`/api/payroll-cycle-transactions/${id}`),
      sync: (id, data) => defaultHttp().patch(`/api/payroll-cycle-transactions/${id}/sync`, data),
      listUnsyncCompanyEmployees: (id) => defaultHttp().get(`/api/payroll-cycle-transactions/${id}/unsync-company-employees`),
      delete: (id, data) => defaultHttp().patch(`/api/payroll-cycle-transactions/${id}/delete`, data),
      import: (id, data) => defaultHttp().post(`/api/payroll-cycle-transactions/${id}/${childResource}-import`, data),
      createMany: (id, data) => defaultHttp().post(`/api/payroll-cycle-transactions/${id}/${childResource}-details`, data),
      compute: (id, data) => defaultHttp().post(`/api/payroll-cycle-transactions/${id}/${childResource}-computing`, data),
      syncAndCompute: (id, data) => defaultHttp().post(`/api/payroll-cycle-transactions/${id}/sync-and-compute`, data),
      epfFormA: (parentId, data, config = {}) => defaultHttp().post(`/api/${secondaryParentResource}/${parentId}/${childResource}-epf-form-a`, data, { responseType: 'blob', ...config }),
      eisImportText: (parentId, data, config = {}) => defaultHttp().post(`/api/${secondaryParentResource}/${parentId}/${childResource}-eis-import-text`, data, { responseType: 'blob', ...config }),
      socsoImportText: (parentId, data, config = {}) => defaultHttp().post(`/api/${secondaryParentResource}/${parentId}/${childResource}-socso-import-text`, data, { responseType: 'blob', ...config }),
      socsoEisImportText: (parentId, data, config = {}) => defaultHttp().post(`/api/${secondaryParentResource}/${parentId}/${childResource}-socso-eis-import-text`, data, { responseType: 'blob', ...config }),
      cp39ImportText: (parentId, data, config = {}) => defaultHttp().post(`/api/${secondaryParentResource}/${parentId}/${childResource}-cp39-import-text`, data, { responseType: 'blob', ...config }),
      epfSocsoEisRhb: (parentId, data, config = {}) => defaultHttp().post(`/api/${secondaryParentResource}/${parentId}/${childResource}-rhb-import-excel`, data, { responseType: 'blob', ...config }),
    }
  },
  payrollCycleEmployees () {
    const parentResource = 'payroll-cycle-employees'

    return {
      show: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}`),
      listInactive: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/list-inactive`),
      removeInactive: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/remove-inactive`, data),
      generateExplanationReport: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/explanation-report`, data),
    }
  },
  payrollCycleTransactionCompanies () {
    const parentResource = 'pc-transaction-companies'

    return {
      show: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}`),
    }
  },
  jobCategories () {
    let resource = 'job-categories'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  jobBands () {
    let resource = 'job-bands'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  jobGroupPolicies () {
    let resource = 'job-group-policies'

    return {
      list: (param = '') => defaultHttp().get('/api/' + resource + param),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  jobGroups () {
    let resource = 'job-groups'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  hrisHolidays () {
    const resource = 'holidays'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  hrisHolidayDetails () {
    const parentResource = 'holidays'
    const resource = 'detail'

    return {
      list: (param) => defaultHttp().get('/api/holiday-details' + param),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${resource}`, data),
      createMany: (data) => defaultHttp().post('/api/holiday-details', data),
      update: (id, data) => defaultHttp().patch(`/api/holiday-details/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/holiday-details/${id}`),
    }
  },
  checkEmployeeIncludedInPayrollPeriods () {
    const parentResource = 'check-employee-in-payroll-period'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}`),
    }
  },
  payrollTransactionDetails () {
    const resource = 'payroll-transaction-details'

    return {
      delete: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      update: (id, data) => defaultHttp().patch(`/api/payroll-transaction-detail-update/${id}`, data),
      listChanges: (id) => defaultHttp().get(`/api/payroll-transaction-detail-changes/${id}`),
      listReferenceCode: (id) => defaultHttp().get(`/api/payroll-cycle-transactions/${id}/list-reference-code`),
      batchDelete: (data) => defaultHttp().post(`/api/${resource}/batch-delete`, data),
    }
  },
  payrollELetters () {
    return {
      bonusLetter: (data, config = {}) => defaultHttp().post(`/api/bonus-letter`, data, { responseType: 'blob', ...config }),
      incrementLetter: (data, config = {}) => defaultHttp().post(`/api/increment-letter`, data, { responseType: 'blob', ...config }),
      promotionLetter: (data, config = {}) => defaultHttp().post(`/api/promotion-letter`, data, { responseType: 'blob', ...config }),
      salaryAdjustmentLetter: (data, config = {}) => defaultHttp().post(`/api/salary-adjustment-letter`, data, { responseType: 'blob', ...config }),
      positionRestructuringLetter: (data, config = {}) => defaultHttp().post(`/api/position-restructuring-letter`, data, { responseType: 'blob', ...config }),
      positionRestructuringLetterV2: (data, config = {}) => defaultHttp().post(`/api/position-restructuring-letter-v2`, data, { responseType: 'blob', ...config }),
    }
  },
  payrollReports () {
    return {
      employeeEpf: (data, config = {}) => defaultHttp().post(`/api/employee-epf-report`, data, { responseType: 'blob', ...config }),
      employeeCp8d: (data, config = {}) => defaultHttp().post(`/api/employee-cp8d-report`, data, { responseType: 'blob', ...config }),
      formEData: (data, config = {}) => defaultHttp().post(`/api/form-e-data-report`, data, { responseType: 'blob', ...config }),
      employeeEa: (data, config = {}) => defaultHttp().post(`/api/employee-ea-form`, data, { responseType: 'blob', ...config }),
      releaseEmployeeEa: (data) => defaultHttp().post(`/api/employee-ea-form/release`, data),
      withdrawEmployeeEa: (data) => defaultHttp().post(`/api/employee-ea-form/withdraw`, data),
      emailEmployeeEa: (data) => defaultHttp().post(`/api/employee-ea-form/email`, data),
      listEaEmployees: (data) => defaultHttp().post(`/api/list-ea-employees`, data), 
      employeeLampiranB: (data, config = {}) => defaultHttp().post(`/api/employee-lampiran-b`, data, { responseType: 'blob', ...config }),     
      employeeCP22A: (data, config = {}) => defaultHttp().post(`/api/employee-cp22a-form`, data, { responseType: 'blob', ...config }),
      listCP22AEmployees: (data) => defaultHttp().post(`/api/list-cp22a-employees`, data),      
      employeeCP22: (data, config = {}) => defaultHttp().post(`/api/employee-cp22-form`, data, { responseType: 'blob', ...config }),
      listCP22Employees: (data) => defaultHttp().post(`/api/list-cp22-employees`, data),
      socsoForm8a: (data) => defaultHttp().post(`/api/socso-form-8a`, data, { responseType: 'blob' }),
      eisLampiranOne: (data) => defaultHttp().post(`/api/eis-lampiran-1`, data, { responseType: 'blob' }),
      epfFormA: (data) => defaultHttp().post(`/api/epf-form-a`, data, { responseType: 'blob' }),
      employeePcbTwo: (data, config = {}) => defaultHttp().post(`/api/employee-pcb-two`, data, { responseType: 'blob', ...config }),
      monthlyPayrollDetail: (data, config = {}) => defaultHttp().post(`/api/monthly-payroll-detail`, data, { responseType: 'blob', ...config }),
      monthlyPayrollReportByCostCenter: (data, config = {}) => defaultHttp().post(`/api/monthly-payroll-report-by-cost-center`, data, { responseType: 'blob', ...config }),
      monthlyPayrollReportByCompany: (data, config = {}) => defaultHttp().post(`/api/monthly-payroll-report-by-company`, data, { responseType: 'blob', ...config }),
      yearlySummaryListing: (data, config = {}) => defaultHttp().post(`/api/yearly-summary-listing`, data, { responseType: 'blob', ...config }),
      yearlyPayrollDetailsByIndividual: (data, config = {}) => defaultHttp().post(`/api/yearly-payroll-details-by-individual`, data, { responseType: 'blob', ...config }),
      yearlyPayrollDetailsByCompany: (data, config = {}) => defaultHttp().post(`/api/yearly-payroll-details-by-company`, data, { responseType: 'blob', ...config }),
      yearlyPayrollDetailsByState: (data, config = {}) => defaultHttp().post(`/api/yearly-payroll-details-by-state`, data, { responseType: 'blob', ...config }),
      yearlyPayrollDetailsByPosition: (data, config = {}) => defaultHttp().post(`/api/yearly-payroll-details-by-position`, data, { responseType: 'blob', ...config }),
      yearlyPayrollDetailsByDepartment: (data, config = {}) => defaultHttp().post(`/api/yearly-payroll-details-by-department`, data, { responseType: 'blob', ...config }),
      yearlyPayrollDetailsByIndividualAndCompany: (data, config = {}) => defaultHttp().post(`/api/yearly-payroll-details-by-individual-and-company`, data, { responseType: 'blob', ...config }),
      yearlyEarningReportByState: (data, config = {}) => defaultHttp().post(`/api/yearly-earning-report-by-state`, data, { responseType: 'blob', ...config }),
      yearlyPayrollExpenditureReport: (data) => defaultHttp().post(`/api/yearly-payroll-expenditure`, data, { responseType: 'blob' }),
      paymentSummary: (data, config = {}) => defaultHttp().post(`/api/payment-summary`, data, { responseType: 'blob', ...config }),
      bankCreditDetail: (data, config = {}) => defaultHttp().post(`/api/bank-credit-detail`, data, { responseType: 'blob', ...config }),
      monthlyVariance: (data, config = {}) => defaultHttp().post(`/api/monthly-variance`, data, { responseType: 'blob', ...config }),
      employeePreviousRemuneration: (data, config = {}) => defaultHttp().post(`/api/employee-previous-remuneration-report`, data, { responseType: 'blob', ...config }),
      monthlyPayrollSummary: (data, config = {}) => defaultHttp().post(`/api/monthly-payroll-summary`, data, { responseType: 'blob', ...config }),
    }
  },
  companyEmployeeCostCenters () {
    const resource = 'company-employee-cost-centers'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  benefitInKinds () {
    const resource = 'benefit-in-kinds'
  
    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}${param}`),
      listTrashed: (param = '') => defaultHttp().get(`/api/trashed-${resource}${param}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  disciplinaryCategories () {
    const resource = 'disciplinary-categories'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  employeeVaccinations () {
    const parentResource = 'employees'
    const childResource = 'employee-vaccinations'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${childResource}`, data),
    }
  },
  employeeMovements () {
    let parentResource = 'employees'
    let childResource = 'movements'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
      listMovementAction: () => defaultHttp().get(`/api/movement-actions`),
    }
  },
  companyEmployeeBenefitInKinds () {
    const resource = 'company-employees'
    const childResource = 'benefit-in-kinds'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${resource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/company-employee-benefit-in-kinds/${id}`, data),
    }
  },
  companyEmployeePerquisites () {
    const resource = 'company-employees'
    const childResource = 'perquisites'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${resource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/company-employee-perquisites/${id}`, data),
    }
  },
  companyEmployeeVolas () {
    const resource = 'company-employees'
    const childResource = 'volas'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${resource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/company-employee-volas/${id}`, data),
    }
  },
  companyEmployeeAdditionalDeductions () {
    const resource = 'company-employees'
    const childResource = 'additional-deductions'

    return {
      list: (parentId, param = '') => defaultHttp().get(`/api/${resource}/${parentId}/${childResource}` + param),
      create: (parentId, data) => defaultHttp().post(`/api/${resource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/company-employee-addi-deductions/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/company-employee-addi-deductions/${id}`),
    }
  },
  payrollForms () {
    return {
      tpOne: () => defaultHttp().get(`/api/tp-one`, { responseType: 'blob' }),
    }
  },
  computationSummary () {
    const parentResource = 'payroll-cycle-transactions'
    const childResource = 'computations'
    
    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  computationDoes () {
    return {
      update: (id, data) => defaultHttp().patch(`/api/computation-does/${id}`, data),
    }
  },
  computationBasicSalary () {
    const resource = 'payroll-cycle-employee-salaries'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      updateStatutory: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/update-statutory`, data),
      updateNettPay: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/update-nett-pay`, data),
    }
  },
  companyEmployeeSalaries () {
    const resource = 'company-employee-salaries'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      increment: (id, data) => defaultHttp().put(`/api/${resource}/${id}/increment`, data),
      list: (id) => defaultHttp().get(`/api/${resource}/${id}`),
    }
  },
  employeePayrollEpf () {
    const parentResource = 'employees'
    const childResource = 'epf'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  employeePayrollIncomeTax () {
    const parentResource = 'employees'
    const childResource = 'income-tax'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  nonResidentTaxes () {
    const resource = 'company-employees'
    const childResource = 'non-resident-taxes'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${resource}/${parentId}/${childResource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
    }
  },
  disciplinaryActions () {
    const resource = 'disciplinary-actions'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  typeOfMisconducts () {
    const resource = 'type-of-misconducts'

    return {
      list: (data) => defaultHttp().post(`/api/get-${resource}`, data),
      listTrashed: (data) => defaultHttp().post(`/api/trashed-${resource}`, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      createMany: (data) => defaultHttp().post(`/api/copy-${resource}`, data),
      updateMany: (data) => defaultHttp().post(`/api/bulk-update-${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  typeOfMisconductRevisions () {
    const resource = 'type-of-misconduct-revisions'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  employeeDisciplineCases () {
    const parentResource = 'employees'
    const childResource = 'disciplinary-cases'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
      upload: (childId, data) => defaultHttp().request({
        url: `/api/${childResource}/${childId}/documents`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
    }
  },
  employeeCompanies () {
    let parentResource = 'employees'
    let childResource = 'companies'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      listAllCompanies: (id) => defaultHttp().get(`/api/${parentResource}/${id}/all-${childResource}`),
      listOrganization: () => defaultHttp().get(`/api/employee-company-organization`),
     }
  },
  companyEmployeeTaxExemptions () {
    const resource = 'company-employees'
    const childResource = 'company-employee-tax-exemptions'

    return {
      list: (parentId) => defaultHttp().get(`/api/${resource}/${parentId}/${childResource}`),
      create: (data) => defaultHttp().post(`/api/${childResource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
    }
  },
  payslips () {
    let parentResource = 'company-employees'
    let childResource = 'payslips'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      download: (parentId, childId, type) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}/${childId}/${type}`, { responseType: 'blob' }),
      releasePayslip: (data) => defaultHttp().post(`/api/${childResource}/release`, data),
      withdrawPayslip: (data) => defaultHttp().post(`/api/${childResource}/withdraw`, data),
      emailPayslip: (data) => defaultHttp().post(`/api/${childResource}/email`, data),
    }
  },
  companyEmployeePcbStatements () {
    let resource = 'pcb-statements'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  companyEmployeePcbArrears () {
    let resource = 'pcb-arrears'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  hrisLeaveTypes () {
    let resource = 'leave-types'

    return {
      list: () => defaultHttp().get(`/api/hris-${resource}`),
      listTrashed: () => defaultHttp().get(`/api/hris-trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/hris-${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/hris-${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/hris-${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/hris-trashed-${resource}/${id}`),
    }
  },
  leaveLockSettings () {
    const resource = 'leave-lock-settings'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      yearFilteredList: (year) => defaultHttp().get(`/api/${resource}-year-filtered/${year}`),
      distinctYear: () => defaultHttp().get('/api/leave-lock-setting-years'),
    }
  },
  leaveEntitlementSettings () {
    const resource = 'leave-entitlement-settings'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  leaveEntitlements () {
    const resource = 'leave-entitlements'

    return {
      list: (data) => defaultHttp().post(`/api/${resource}-by-types`, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      createMany: (data) => defaultHttp().post(`/api/${resource}/batch-copy`, data),
      update: (parentId, data) => defaultHttp().patch(`/api/${resource}/${parentId}`, data),
      updateProratedDays: (parentId, data) => defaultHttp().post(`/api/${resource}/update-prorated-days/${parentId}`, data),
      destroy: (parentId) => defaultHttp().delete(`/api/${resource}/${parentId}`),
      listEntitlementYear: () => defaultHttp().get('/api/leave-entitlement-years'),
    }
  },
  leaveForecast () {
    const resource = 'leave-entitlements'

    return {
      forecastProratedDays: (parentId, data) => defaultHttp().post(`/api/${resource}/forecast-prorated-days/${parentId}`, data),
      updateForecastProratedDays: (parentId, data) => defaultHttp().post(`/api/${resource}/update-forecast-prorated-days/${parentId}`, data),
    }
  },
  claimTypes () {
    let resource = 'claim-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listEmployeeClaims: (id) => defaultHttp().get(`/api/employee-claims/${id}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  claimEntitlementSettings () {
    const resource = 'claim-entitlement-settings'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  claimEntitlementSettingDetails () {
    const resource = 'claim-entitlement-setting-details'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  claimEntitlements () {
    const resource = 'claim-entitlements'

    return {
      list: (param, data) => defaultHttp().post(`/api/${resource}` + param, data),
      getTotalEntitlements: (data) => defaultHttp().post(`/api/get-total-${resource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      listYear: () => defaultHttp().get(`/api/claim-entitlement-years`),
    }
  },
  claimEntitlementAdjustments () {
    let parentResource = 'claim-entitlements'
    let resource = 'adjustments'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  claimTransactionDateValidityRules () {
    let resource = 'transaction-date-validity-rules'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  claimRequests () {
    let parentResource = 'employees'
    let resource = 'claim-requests'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      listClaimCycles: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/claim-cycle`),
      create: (parentId, id, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/claim-cycles/${id}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      cancel: (id) => defaultHttp().patch(`/api/${resource}/${id}/cancel`),
      updateCompany: (id, data) => defaultHttp().post(`/api/${resource}/${id}/company`, data),
    }
  },
  claimRequestEscalations () {
    let parentResource = 'claim-requests'
    let resource = 'claim-request-escalations'

    return {
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/escalations`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  claimRequestEntries () {
    let resource = 'claim-request-entries'

    return {
      create: (data) => defaultHttp().post(`/api/create-${resource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().post(`/api/update-${resource}/${id}`, data),
    }
  },
  claimRequestEntryDocuments () {
    let parentResource = 'claim-request-entries'
    let childResource = 'documents'

    return {
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${childResource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${parentResource}/${childResource}/${id}`),
    }
  },
  claimAssignees () {
    let resource = 'claim-assignees'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}` + param),
      listTrashed: (param = '') => defaultHttp().get(`/api/trashed-${resource}` + param),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  claimAssigneeCompanies () {
    let resource = 'claim-assignee-companies'

    return {
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  backupApprovers () {
    let resource = 'backup-approvers'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      listBackup: (id) => defaultHttp().get(`/api/list-backup-approvers/${id}`),
    }
  },
  claimApprovalWorkflowBatches () {
    let resource = 'claim-approval-workflow-batches'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
      copy: (id, data) => defaultHttp().put(`/api/copy-${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  claimApprovals () {
    const resource = 'claim-approvals'

    return {
      list: (param, data) => defaultHttp().post(`/api/claim-approval-overviews` + param, data),
      approve: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/approve`, data),
      reject: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/reject`, data),
      requestMore: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/request-more`, data),
      escalate: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/escalate`, data),
      revert: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/revert`, data),
      complete: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/complete`, data),
      pendingCount: () => defaultHttp().get(`/api/${resource}/pending-count`),
    }
  },
  claimReports () {
    return {
      list: (data) => defaultHttp().post(`/api/list-claims`, data),
      generateClaimReport: (data) => defaultHttp().post(`/api/claim-report`, data, { responseType: 'blob' }),
      downloadDocuments: (data, config = {}) => defaultHttp().post(`/api/claim-supporting-documents`, data, { responseType: 'blob', ...config }),
    }
  },
  claimRequestApprovals () {
    const parentResource = 'claim-requests'
    const childResource = 'approvals'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  onBehalfClaimApplications () {
    let resource = 'on-behalf-claims'
    
    return {
      list: (data) => defaultHttp().post(`/api/list-${resource}`, data),
    }
  },
  claimCycles () {
    const resource = 'claim-cycles'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}` + param),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      listYears: () => defaultHttp().get(`/api/claim-cycle-years`),
    }
  },
  claimBulkpays () {
    const resource = 'claim-bulkpays'

    return {
      list: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (data) => defaultHttp().patch(`/api/bulk-update-claim-requests`, data),
      revert: (data) => defaultHttp().patch(`/api/bulk-revert-claim-requests`, data),
      generate: (data, config = {}) => defaultHttp().post(`/api/generate-${resource}`, data, { responseType: 'blob', ...config }),
    }
  },
  claimPolicies () {
    const parentResource = 'job-group-policies'
    const childResource = 'claims'

    return {
      list: () => defaultHttp().get(`/api/job-group-policy-${childResource}`),
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  jobGroupPolicyClaims () {
    const resource = 'job-group-policy-claims'

    return {
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  hrisRoles () {
    const resource = 'hris-roles' 

    return {
      list: () => defaultHttp().get('/api/' + resource),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  permissionGroups () {
    const resource = 'permission-groups' 

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  rolePermissions () {
    const parentResource = 'roles'
    const childResource = 'permissions'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (id, data) => defaultHttp().put(`/api/${parentResource}/${id}/${childResource}`, data),
    }
  },
  jobGrades () {
    let resource = 'job-grades'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  companyEmployeePreviousTaxReliefs () {
    const resource = 'company-employees'
    const childResource = 'previous-additional-deductions'

    return {
      list: (parentId) => defaultHttp().get(`/api/${resource}/${parentId}/${childResource}`),
      create: (data) => defaultHttp().post(`/api/company-employee-p-add-deductions`, data),
      update: (id, data) => defaultHttp().put(`/api/company-employee-p-add-deductions/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/company-employee-p-add-deductions/${id}`),
    }
  },
  employeeProbations () {
    const resource = 'employee-probations'
    
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listCompleted: () => defaultHttp().get(`/api/completed-${resource}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      confirm: (id, data) => defaultHttp().patch(`/api/confirm-${resource}/${id}`, data),
    }
  },
  probationReports () {
    const resource = 'probation-reports'

    return {
      probationReport: (data) => defaultHttp().post(`/api/${resource}`, data, { responseType: 'blob' }),
    }
  },
  attendanceReports () {
    return {
      generateAttendanceDetailReport: (data, config = {}) => defaultHttp().post(`/api/attendance-detail-report`, data, { responseType: 'blob', ...config }),
      generateAttendanceSummaryReport: (data, config = {}) => defaultHttp().post(`/api/attendance-summary-report`, data, { responseType: 'blob', ...config }),
    }
  },
  payrollImports () {
    return {
      salaryIncrementImport: (data) => defaultHttp().post(`/api/salary-increment-import`, data),
      bankEpfIncomeTaxImport: (data) => defaultHttp().post(`/api/bank-epf-income-tax-import`, data),
      employeeContributionImport: (data) => defaultHttp().post(`/api/employee-contribution-import`, data),
    }
  },
  exportToBanks () {
    return {
      export: (bank, payrollPeriodId, data) => defaultHttp().post(`/api/${bank}-payroll-export/${payrollPeriodId}`, data, { responseType: 'blob' }),
    }
  },
  payrollExports () {
    return {
      employeeContributionExport: (data) => defaultHttp().post(`/api/employee-contribution-export`, data, { responseType: 'blob' }),
      employeeStatutoryExport: (data) => defaultHttp().post(`/api/employee-statutory-export`, data, { responseType: 'blob' }),
    }
  },
  pcbStatements () {
    const resource = 'pcb-statement-bulk'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
    }
  },
  pcbArrears () {
    const resource = 'pcb-arrear-bulk'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
    }
  }, 
  dutyRosters () {
    let parentResource = 'employees'
    let childResource = 'duty-rosters'

    return {
      list: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${childResource}`, data),
      listAll: (param = '') => defaultHttp().get(`/api/list-${childResource}` + param),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/duty-roster`, data),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
      createMany: (data) => defaultHttp().post(`/api/${childResource}/store-many`, data),
      import: (data) => defaultHttp().post(`/api/import-${childResource}`, data),
    }
  },
  shiftCodes () {
    let parentResource = 'work-session-types'
    let childResource = 'shift-codes'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/shift-code`, data),
      update: (id, data) => defaultHttp().put(`/api/work-session-${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/work-session-${childResource}/${id}`),
    }
  },
  employeeShiftCodes () {
    let parentResource = 'employees'
    let childResource = 'shift-codes'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
    }
  },
}
